var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOwnerMegaphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.5 10s-.625-.234-.625-1.25S2.5 7.5 2.5 7.5m15 2.11s.625-.17.625-.86-.625-.86-.625-.86M10 6.25v5m-5.625-5v5m11.56-9.21s-3.384 4.21-6.56 4.21h-6.25a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 .625.625h6.25c3.176 0 6.56 4.228 6.56 4.228.237.312.94.098.94-.384V2.422c0-.48-.664-.735-.94-.382"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.625 11.25v6.563a.313.313 0 0 0 .313.312h2.07a.624.624 0 0 0 .597-.81c-.327-1.05-1.105-2.234-1.105-4.19h.625a.625.625 0 0 0 .625-.625v-.625a.625.625 0 0 0-.625-.625H7.5"
}))));
export default SvgIconOwnerMegaphone;